(function () {
  const publish = (name, data) => {
    try {
      window.Shopify?.analytics?.publish(name, data);
    } catch (e) {}
  };

  // select_item click event on a product from a grid or carousel
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-item-list] a[href*="/products/"]');
    if (!link) return;
    const card = link.closest('[data-ga-product-id]');
    const list = link.closest('[data-item-list]');
    if (!card || !list) return;

    publish('custom:select_item', {
      item_list_id: list.dataset.itemListId,
      item_list_name: list.dataset.itemList,
      item_id: card.dataset.gaProductId,
      item_name: card.dataset.gaProductTitle,
      price: card.dataset.gaProductPrice
        ? parseFloat(card.dataset.gaProductPrice)
        : undefined,
      index: card.dataset.gaIndex
        ? parseInt(card.dataset.gaIndex, 10)
        : undefined,
    });
  });

  //autocomplete_search predictive search event
  document.addEventListener('click', (e) => {
    const path = e.composedPath ? e.composedPath() : [];
    const link =
      path.find((el) => el.tagName === 'A' && el.getAttribute('href')) ||
      e.target.closest('a[href]');
    if (!link) return;

    const inDropdown =
      path.some(
        (el) =>
          el.classList &&
          el.classList.contains('predictive-search__results-flat'),
      ) || link.closest('.predictive-search__results-flat');
    if (!inDropdown) return;

    const href = link.getAttribute('href') || '';
    let type = 'other';
    if (
      link.classList.contains('predictive-search__category-item') ||
      href.includes('/collections/')
    )
      type = 'collection';
    else if (href.includes('/products/')) type = 'product';

    const input =
      document.querySelector('#predictive-search-form input[name="q"]') ||
      document.querySelector('input[name="q"]');

    publish('custom:autocomplete_search', {
      search_term: (input?.value || '').trim().slice(0, 100),
      suggestion: (link.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 100),
      suggestion_type: type,
      suggestion_url: href,
    });
  });

  // add_to_wishlist event from Swym Wishlist Plus
  function onSwymLoad(swat) {
    if (!swat?.evtLayer || onSwymLoad.done) return;
    onSwymLoad.done = true;

    swat.evtLayer.addEventListener('sw:addedtowishlist', (event) => {
      const product = event.detail?.d;
      if (!product) return;

      publish('custom:add_to_wishlist', {
        item_id: String(product.empi),
        item_name: product.dt,
        item_variant: String(product.epi),
        price: parseFloat(product.pr) || undefined,
        currency: window.Shopify?.currency?.active,
        item_url: product.du,
        source: product.source,
      });
    });
  }

  if (window._swat?.evtLayer) onSwymLoad(window._swat);

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymLoad);
})();
